import { Primitive } from './Primitive';
import { Type } from './Type';
export class ArrayND extends Primitive {
    buffer;
    dataType;
    shape;
    constructor(buffer, dataType, shape) {
        super(Type.ArrayND);
        this.buffer = buffer;
        this.dataType = dataType;
        this.shape = shape;
    }
}
/* istanbul ignore next */
// eslint-disable-next-line @typescript-eslint/no-namespace
(function (ArrayND) {
    let DataType;
    (function (DataType) {
        DataType["Boolean"] = "bool";
        DataType["Float16"] = "float16";
        DataType["Float32"] = "float32";
        DataType["Float64"] = "float64";
        DataType["Integer16"] = "int16";
        DataType["Integer32"] = "int32";
        DataType["Integer64"] = "int64";
        DataType["Integer8"] = "int8";
        DataType["UnsignedInteger16"] = "uint16";
        DataType["UnsignedInteger32"] = "uint32";
        DataType["UnsignedInteger64"] = "uint64";
        DataType["UnsignedInteger8"] = "uint8";
    })(DataType = ArrayND.DataType || (ArrayND.DataType = {}));
})(ArrayND || (ArrayND = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXJyYXlORC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvQXJyYXlORC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sYUFBYSxDQUFBO0FBQ3ZDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxRQUFRLENBQUE7QUFFN0IsTUFBTSxPQUFPLE9BQVEsU0FBUSxTQUFTO0lBQzNCLE1BQU0sQ0FBb0I7SUFDMUIsUUFBUSxDQUFrQjtJQUMxQixLQUFLLENBQWE7SUFFM0IsWUFDRSxNQUEwQixFQUMxQixRQUEwQixFQUMxQixLQUFrQjtRQUVsQixLQUFLLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFBO1FBQ25CLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFBO1FBQ3BCLElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFBO1FBQ3hCLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFBO0lBQ3BCLENBQUM7Q0FDRjtBQUVELDBCQUEwQjtBQUMxQiwyREFBMkQ7QUFDM0QsV0FBaUIsT0FBTztJQWN0QixJQUFZLFFBYVg7SUFiRCxXQUFZLFFBQVE7UUFDbEIsNEJBQWdCLENBQUE7UUFDaEIsK0JBQW1CLENBQUE7UUFDbkIsK0JBQW1CLENBQUE7UUFDbkIsK0JBQW1CLENBQUE7UUFDbkIsK0JBQW1CLENBQUE7UUFDbkIsK0JBQW1CLENBQUE7UUFDbkIsK0JBQW1CLENBQUE7UUFDbkIsNkJBQWlCLENBQUE7UUFDakIsd0NBQTRCLENBQUE7UUFDNUIsd0NBQTRCLENBQUE7UUFDNUIsd0NBQTRCLENBQUE7UUFDNUIsc0NBQTBCLENBQUE7SUFDNUIsQ0FBQyxFQWJXLFFBQVEsR0FBUixnQkFBUSxLQUFSLGdCQUFRLFFBYW5CO0FBQ0gsQ0FBQyxFQTVCZ0IsT0FBTyxLQUFQLE9BQU8sUUE0QnZCIn0=